import { AnimatePresence, motion } from "motion/react";
import { FC, useEffect } from "react";
import { useSetRecoilState } from "recoil";

import {
  IGridRowProps,
  TableWrapperGeneric,
  useTableDefsRides,
} from "@ryde/controls";
import { useRidesGridSplitter } from "@ryde/redux";
import {
  IColumnDef,
  IExtendableDto,
  IRideDto,
  RidesViewTypeEnum,
  selectedSingleRowRideIdAtom,
} from "@ryde/shared";

import { RidesRoutes } from "../../routes";
import { GridRowRendererRides, RideDetailsPanel } from "../grid";
import { RidesGridTableWrapperStyled } from "./rides-grid.styled";
import { RidesMapSingleSelect } from "./rides-map-single-select";

export const RidesGridSingleSelect: FC = () => {
  const setSelectedSingleRowRideId = useSetRecoilState(
    selectedSingleRowRideIdAtom,
  );
  useEffect(() => {
    return () => setSelectedSingleRowRideId(undefined);
  }, [setSelectedSingleRowRideId]);

  const { tableDefsRides } = useTableDefsRides();
  const {
    mapOpen,
    x,
    onDragStartHandler,
    onDragEndHandler,
    gridSizeProps,
    mapSizeProps,
    dragConstraints,
  } = useRidesGridSplitter(RidesViewTypeEnum.GridSingleSelect);

  return (
    <>
      <RidesGridTableWrapperStyled>
        <motion.div className="grid_panel thin_scrollbar" style={gridSizeProps}>
          <TableWrapperGeneric
            RenderSubComponent={({ row }) => {
              return <RideDetailsPanel rideDto={row.original as IRideDto} />;
            }}
            GridRowRenderer={
              GridRowRendererRides as unknown as FC<
                IGridRowProps<IExtendableDto>
              >
            }
            tableDefs={tableDefsRides as IColumnDef<IExtendableDto, any>[]}
          />
        </motion.div>
        <AnimatePresence>
          {mapOpen && (
            <motion.div
              className="splitter"
              key="splitter"
              dragElastic={0}
              dragMomentum={false}
              onDragStart={onDragStartHandler}
              onDragEnd={onDragEndHandler}
              dragConstraints={dragConstraints}
              drag="x"
              style={{
                cursor: "col-resize",
                x,
              }}
            />
          )}

          {mapOpen && (
            <motion.div
              key="map_panel"
              className="map_panel"
              style={mapSizeProps}
            >
              <RidesMapSingleSelect />
            </motion.div>
          )}
        </AnimatePresence>
      </RidesGridTableWrapperStyled>
      <RidesRoutes />
    </>
  );
};
